<template>
  <div class="layouts-parts-container-style">
    <ul class="editor-design">
      <li>
        パーツの背景色
      </li>
      <li class="flex-box">
        <!-- 背景色 -->
        <select-color
          :type="'partsContainer'"
          :target="'outer-background'"
          :selector="null"
          :value="styles ? styles['outer-background'] : null"
          @updateStyles="updateStyles($event, 'outer-background')"
          class="background"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'

export default {
  props: [
    'styles',
    'sectionId',
    'partsContainerId',
    'partsContainerType'
  ],
  components: {
    SelectColor,
  },
  methods: {
    updateStyles (styles, prop) {
      this.$store.commit('updatePartsContainerStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        styles,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.flex-box {
  &.last {
    margin-bottom: 0;
    padding-bottom: 10px;
  }
}
</style>
